module.exports = __webpack_public_path__ + "9a63eb8b8dfd94d11761cfe8b30ebade.png";